import { Paragraph } from '@almbrand/paragraph';
import { CURRENCY_MONTHLY_SHORT, CURRENCY_SHORT } from '../Basket';
import { BasketSummaryLine } from '../Basket.types';
import { BasketTile } from '../BasketTile';
import styles from './BasketSummaryCard.module.scss';

interface BasketSummaryCardProps {
	discountLines: BasketSummaryLine[];
	totalAmount: number;
	taxAmount?: number;
	text: {
		totalLabel: string;
		legalText: string;
	};
}

export type BasketSummaryCardText = BasketSummaryCardProps['text'];

export const BasketSummaryCard: React.FC<BasketSummaryCardProps> = ({
	discountLines,
	totalAmount,
	taxAmount,
	text: { totalLabel, legalText } = {},
}) => {
	return (
		<BasketTile
			element='section'
			bgColor='var(--color-primary-5)'
			className={styles.BasketSummaryCard}
		>
			<div>
				{discountLines.map((line) => (
					<div
						key={line.label}
						className={styles.BasketSummaryCard__discountLine}
					>
						<Paragraph
							text={line.label}
							paragraphType={{ kind: 'label', size: 'default' }}
						/>
						<Paragraph
							className={styles.BasketSummaryCard__discountLineAmount}
							text={line.value}
							paragraphType={{ kind: 'label', size: 'default' }}
						/>
					</div>
				))}
			</div>

			<div className={styles.BasketSummaryCard__total}>
				<Paragraph
					className={styles.BasketSummaryCard__totalLabel}
					text={totalLabel}
					paragraphType={{ kind: 'label', size: 'default' }}
				/>
				<Paragraph
					className={styles.BasketSummaryCard__totalAmount}
					text={`${String(totalAmount)} ${CURRENCY_MONTHLY_SHORT}`}
					paragraphType={{ kind: 'label', size: 'default' }}
				/>
				{!!taxAmount && (
					<div className={styles.BasketSummaryCard__taxAmount}>
						<Paragraph
							text={legalText}
							paragraphType={{ kind: 'label', size: 'default' }}
						/>
						<Paragraph
							className={styles.BasketSummaryCard__taxAmountAmount}
							text={`${String(taxAmount)} ${CURRENCY_SHORT}`}
							paragraphType={{ kind: 'label', size: 'default' }}
						/>
					</div>
				)}
			</div>
		</BasketTile>
	);
};
